import PhoneAndroid from '@mui/icons-material/PhoneAndroid';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function MobileIcon(props: FixMe) {
  return <PhoneAndroid {...props} />;
}

export default MobileIcon;
